function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var LayerGroup = /*#__PURE__*/function () {
  function LayerGroup(id, groupMethod, title, description, parentId, groups) {
    _classCallCheck(this, LayerGroup);
    this.id = id;
    this.groupMethod = groupMethod;
    this.name = title;
    this.description = description;
    this.layers = [];
    this.parentId = parentId || null;
    this.groups = groups || [];
    this.searchIndex = {};
    this.tools = [];
    this._isAdmin = Oskari.user().isAdmin();
  }
  return _createClass(LayerGroup, [{
    key: "getParentId",
    value: function getParentId() {
      return this.parentId;
    }
  }, {
    key: "setParentId",
    value: function setParentId(parentId) {
      this.parentId = parentId;
    }
  }, {
    key: "getGroups",
    value: function getGroups() {
      return this.groups;
    }
  }, {
    key: "setGroups",
    value: function setGroups(newGroups) {
      this.groups = newGroups;
    }

    /**
     * @method getId
     * @return {String}
     */
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }

    /**
     * @return {Boolean}
     */
  }, {
    key: "isEditable",
    value: function isEditable() {
      return this.id > 0;
    }

    /**
     * @method groupMethod
     * @return {String}
     */
  }, {
    key: "getGroupMethod",
    value: function getGroupMethod() {
      return this.groupMethod;
    }

    /**
     * @method setTitle
     * @param {String} name
     */
  }, {
    key: "setTitle",
    value: function setTitle(name) {
      this.name = name;
    }

    /**
     * @method getTitle
     * @return {String}
     */
  }, {
    key: "getTitle",
    value: function getTitle() {
      return this.name || '';
    }
  }, {
    key: "setDescription",
    value: function setDescription(description) {
      this.description = description;
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      return this.description;
    }

    /**
     * @method addLayer
     * @param {Layer} layer
     */
  }, {
    key: "addLayer",
    value: function addLayer(layer) {
      if (this.searchIndex[layer.getId()]) {
        // Tried adding the same layer again
        return;
      }
      this.layers.push(layer);
      this.searchIndex[layer.getId()] = this._getSearchIndex(layer);
    }
  }, {
    key: "getLayerCount",
    value: function getLayerCount() {
      return this.getGroups().reduce(function (prev, cur) {
        return prev + cur.getLayerCount();
      }, this.layers.length);
    }

    /**
     * @method addTool
     * @param {Oskari.mapframework.domain.Tool} tool
     */
  }, {
    key: "setTools",
    value: function setTools(tools) {
      this.tools = tools;
    }
  }, {
    key: "getTools",
    value: function getTools() {
      return this.tools;
    }

    /**
     * @method getLayers
     * @return {Layer[]}
     */
  }, {
    key: "getLayers",
    value: function getLayers() {
      return this.layers;
    }
  }, {
    key: "setLayers",
    value: function setLayers() {
      var _this = this;
      var newLayers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.layers = [];
      this.searchIndex = {};
      newLayers.forEach(function (layer) {
        return _this.addLayer(layer);
      });
    }
  }, {
    key: "_getSearchIndex",
    value: function _getSearchIndex(layer) {
      var index = layer.getGroups().map(function (group) {
        return group.name;
      });
      index.push(layer.getName());
      index.push(layer.getOrganizationName());
      if (this._isAdmin) {
        index.push(layer.getId());
        index.push(layer.getLayerName());
      }
      return index.filter(function (nonEmpty) {
        return nonEmpty;
      }).join(' ').toLowerCase();
    }
  }, {
    key: "matchesKeyword",
    value: function matchesKeyword(layerId, keyword) {
      var searchableIndex = this.searchIndex[layerId];
      var terms = keyword;
      if (!Array.isArray(terms)) {
        terms = [terms];
      }
      return terms.every(function (key) {
        return searchableIndex.indexOf(key.toLowerCase()) !== -1;
      });
    }
  }, {
    key: "clone",
    value: function clone() {
      var clone = new LayerGroup(this.id, this.groupMethod, this.name, this.description, this.parentId);
      clone.layers = _toConsumableArray(this.layers);
      clone.groups = _toConsumableArray(this.groups);
      clone.searchIndex = _objectSpread({}, this.searchIndex);
      clone.tools = _toConsumableArray(this.tools);
      return clone;
    }
  }]);
}();
;